var _defs, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _line150, _line151, _line152;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3840 2160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-1,.cls-2{stroke:rgba(255,255,255,.3);stroke-width:1px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 3840,
    height: 2160
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x2: 3840
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    y1: 2160
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40,
    y1: 2160,
    x2: 40
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 80,
    y1: 2160,
    x2: 80
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 120,
    y1: 2160,
    x2: 120
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 160,
    y1: 2160,
    x2: 160
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 200,
    y1: 2160,
    x2: 200
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 240,
    y1: 2160,
    x2: 240
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 280,
    y1: 2160,
    x2: 280
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 320,
    y1: 2160,
    x2: 320
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 360,
    y1: 2160,
    x2: 360
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 400,
    y1: 2160,
    x2: 400
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 440,
    y1: 2160,
    x2: 440
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 480,
    y1: 2160,
    x2: 480
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 520,
    y1: 2160,
    x2: 520
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 560,
    y1: 2160,
    x2: 560
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 600,
    y1: 2160,
    x2: 600
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 640,
    y1: 2160,
    x2: 640
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 680,
    y1: 2160,
    x2: 680
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 720,
    y1: 2160,
    x2: 720
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 760,
    y1: 2160,
    x2: 760
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 800,
    y1: 2160,
    x2: 800
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 840,
    y1: 2160,
    x2: 840
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 880,
    y1: 2160,
    x2: 880
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 920,
    y1: 2160,
    x2: 920
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 960,
    y1: 2160,
    x2: 960
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1000,
    y1: 2160,
    x2: 1000
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1040,
    y1: 2160,
    x2: 1040
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1080,
    y1: 2160,
    x2: 1080
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1120,
    y1: 2160,
    x2: 1120
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1160,
    y1: 2160,
    x2: 1160
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1200,
    y1: 2160,
    x2: 1200
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1240,
    y1: 2160,
    x2: 1240
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1280,
    y1: 2160,
    x2: 1280
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1320,
    y1: 2160,
    x2: 1320
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1360,
    y1: 2160,
    x2: 1360
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1400,
    y1: 2160,
    x2: 1400
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1440,
    y1: 2160,
    x2: 1440
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1480,
    y1: 2160,
    x2: 1480
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1520,
    y1: 2160,
    x2: 1520
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1560,
    y1: 2160,
    x2: 1560
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1600,
    y1: 2160,
    x2: 1600
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1640,
    y1: 2160,
    x2: 1640
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1680,
    y1: 2160,
    x2: 1680
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1720,
    y1: 2160,
    x2: 1720
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1760,
    y1: 2160,
    x2: 1760
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1800,
    y1: 2160,
    x2: 1800
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1840,
    y1: 2160,
    x2: 1840
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1880,
    y1: 2160,
    x2: 1880
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1920,
    y1: 2160,
    x2: 1920
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1960,
    y1: 2160,
    x2: 1960
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2000,
    y1: 2160,
    x2: 2000
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2040,
    y1: 2160,
    x2: 2040
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2080,
    y1: 2160,
    x2: 2080
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2120,
    y1: 2160,
    x2: 2120
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2160,
    y1: 2160,
    x2: 2160
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2200,
    y1: 2160,
    x2: 2200
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2240,
    y1: 2160,
    x2: 2240
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2280,
    y1: 2160,
    x2: 2280
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2320,
    y1: 2160,
    x2: 2320
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2360,
    y1: 2160,
    x2: 2360
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2400,
    y1: 2160,
    x2: 2400
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2440,
    y1: 2160,
    x2: 2440
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2480,
    y1: 2160,
    x2: 2480
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2520,
    y1: 2160,
    x2: 2520
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2560,
    y1: 2160,
    x2: 2560
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2600,
    y1: 2160,
    x2: 2600
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2640,
    y1: 2160,
    x2: 2640
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2680,
    y1: 2160,
    x2: 2680
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2720,
    y1: 2160,
    x2: 2720
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2760,
    y1: 2160,
    x2: 2760
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2800,
    y1: 2160,
    x2: 2800
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2840,
    y1: 2160,
    x2: 2840
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2880,
    y1: 2160,
    x2: 2880
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2920,
    y1: 2160,
    x2: 2920
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2960,
    y1: 2160,
    x2: 2960
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3000,
    y1: 2160,
    x2: 3000
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3040,
    y1: 2160,
    x2: 3040
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3080,
    y1: 2160,
    x2: 3080
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3120,
    y1: 2160,
    x2: 3120
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3160,
    y1: 2160,
    x2: 3160
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3200,
    y1: 2160,
    x2: 3200
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3240,
    y1: 2160,
    x2: 3240
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3280,
    y1: 2160,
    x2: 3280
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3320,
    y1: 2160,
    x2: 3320
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3360,
    y1: 2160,
    x2: 3360
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3400,
    y1: 2160,
    x2: 3400
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3440,
    y1: 2160,
    x2: 3440
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3480,
    y1: 2160,
    x2: 3480
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3520,
    y1: 2160,
    x2: 3520
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3560,
    y1: 2160,
    x2: 3560
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3600,
    y1: 2160,
    x2: 3600
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3640,
    y1: 2160,
    x2: 3640
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3680,
    y1: 2160,
    x2: 3680
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3720,
    y1: 2160,
    x2: 3720
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3760,
    y1: 2160,
    x2: 3760
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3800,
    y1: 2160,
    x2: 3800
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3840,
    y1: 2160,
    x2: 3840
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 40,
    x2: 3840,
    y2: 40
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 80,
    x2: 3840,
    y2: 80
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 120,
    x2: 3840,
    y2: 120
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 160,
    x2: 3840,
    y2: 160
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 200,
    x2: 3840,
    y2: 200
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 240,
    x2: 3840,
    y2: 240
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 280,
    x2: 3840,
    y2: 280
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 320,
    x2: 3840,
    y2: 320
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 360,
    x2: 3840,
    y2: 360
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 400,
    x2: 3840,
    y2: 400
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 440,
    x2: 3840,
    y2: 440
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 480,
    x2: 3840,
    y2: 480
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 520,
    x2: 3840,
    y2: 520
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 560,
    x2: 3840,
    y2: 560
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 600,
    x2: 3840,
    y2: 600
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 640,
    x2: 3840,
    y2: 640
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 680,
    x2: 3840,
    y2: 680
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 720,
    x2: 3840,
    y2: 720
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 760,
    x2: 3840,
    y2: 760
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 800,
    x2: 3840,
    y2: 800
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 840,
    x2: 3840,
    y2: 840
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 880,
    x2: 3840,
    y2: 880
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 920,
    x2: 3840,
    y2: 920
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 960,
    x2: 3840,
    y2: 960
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1000,
    x2: 3840,
    y2: 1000
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1040,
    x2: 3840,
    y2: 1040
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1080,
    x2: 3840,
    y2: 1080
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1120,
    x2: 3840,
    y2: 1120
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1160,
    x2: 3840,
    y2: 1160
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1200,
    x2: 3840,
    y2: 1200
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1240,
    x2: 3840,
    y2: 1240
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1280,
    x2: 3840,
    y2: 1280
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1320,
    x2: 3840,
    y2: 1320
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1360,
    x2: 3840,
    y2: 1360
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1400,
    x2: 3840,
    y2: 1400
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1440,
    x2: 3840,
    y2: 1440
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1480,
    x2: 3840,
    y2: 1480
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1520,
    x2: 3840,
    y2: 1520
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1560,
    x2: 3840,
    y2: 1560
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1600,
    x2: 3840,
    y2: 1600
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1640,
    x2: 3840,
    y2: 1640
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1680,
    x2: 3840,
    y2: 1680
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1720,
    x2: 3840,
    y2: 1720
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1760,
    x2: 3840,
    y2: 1760
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1800,
    x2: 3840,
    y2: 1800
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1840,
    x2: 3840,
    y2: 1840
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1880,
    x2: 3840,
    y2: 1880
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1920,
    x2: 3840,
    y2: 1920
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 1960,
    x2: 3840,
    y2: 1960
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 2000,
    x2: 3840,
    y2: 2000
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 2040,
    x2: 3840,
    y2: 2040
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 2080,
    x2: 3840,
    y2: 2080
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 2120,
    x2: 3840,
    y2: 2120
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 2160,
    x2: 3840,
    y2: 2160
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid01);
export default __webpack_public_path__ + "static/media/grid-01.4d68e0736cc3692e9ebf877493d54e78.svg";
export { ForwardRef as ReactComponent };